import { combineReducers } from "@reduxjs/toolkit";
import userSlice from "./userSlice";
import courseSlice from "./courseSlice";

const Slices = combineReducers({
  User: userSlice,
  Course: courseSlice,
});
export default Slices;
